import React from 'react';
import { useTranslation } from 'react-i18next';

import type { Contact, ListType } from '../../types';

import checkCircleIcon from '../../assets/icons/check_circle.svg?raw&inline';
import editIcon from '../../assets/icons/edit.svg?raw&inline';
import addIcon from '../../assets/icons/add.svg?raw&inline';
import deleteIcon from '../../assets/icons/delete.svg?raw&inline';

export const CompanyRoleCard: React.FC<CompanyRoleCardProps> = ({
  index,
  member,
  isBeneficiaryCard,
  onModalOpen,
  onDeleteClick,
}) => {
  const { t } = useTranslation();

  // Derived state: A contact is submitted if it has both email and phone
  const isSubmitted = !!(member.email && member.telefono);

  const handleCardClass = () => {
    if (isSubmitted && !isBeneficiaryCard) {
      return 'card p-3 my-2 kyb-card-selected text-white bg-white w-100 cursor-pointer';
    } else if (isSubmitted && isBeneficiaryCard) {
      return 'card p-3 my-2 kyb-card-selected text-white bg-white w-100';
    }

    return 'card my-2 p-3 w-100 cursor-pointer';
  };

  const handleCardClick = () => {
    if (isBeneficiaryCard) return;

    onModalOpen(index);
  };

  return (
    <div 
      id={`company-role-card-${index}`}
      className={`col-12 col-md-6 d-flex align-items-stretch px-0 ${(index % 2) === 0 ? 'ps-md-0 pe-md-2' : 'ps-md-2 pe-md-0'}`}
    >
      <div className={handleCardClass()} onClick={handleCardClick}>
        <div className="d-flex gap-2">
          {isSubmitted && 
            <span 
              className="d-flex text-green" 
              dangerouslySetInnerHTML={{ __html: checkCircleIcon }} 
            />
          }
          <div className="row d-flex align-items-center h-100 w-100">
            <div className="col-12 col-sm-8">
              <div className="d-flex align-items-start justify-content-start">
                <div>
                  <p className="text-dark font-weight-600 size-14 mb-0 text-uppercase">{member.nombre}</p>
                  {!member.cargo.includes('beneficiario') && 
                    <p className="text-muted size-12 mb-0">{member.cargo}</p>}
                  {isSubmitted && (
                    <div className="d-flex align-items-center justify-content-start">
                      <p className="text-muted size-12 mb-0 me-2">{member.email}</p>
                      <p className="text-muted size-12 mb-0">{member.telefono}</p>
                      {!isBeneficiaryCard &&
                        <p className="text-muted size-12 mb-0 ms-2">{Number(member.porcentaje_beneficio) > 0 && Number(member.porcentaje_beneficio) + '%'}</p>
                      }
                    </div>
                  )}
                  {isBeneficiaryCard &&
                    <p className="text-green font-weight-400 size-12 mb-0">{t('kyb_flow.beneficiaries.stake', {stake: member.porcentaje_beneficio})}</p>
                  }
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-4 text-end ps-0">
                {isBeneficiaryCard && member.cargo.includes('beneficiario') ? (
                  <button
                    className={`btn btn-link size-12 font-weight-400 p-0 d-flex align-items-center justify-content-sm-end text-decoration-none w-100 ${isSubmitted ? 'text-dark' : 'hyperlink'}`}
                    onClick={() => onDeleteClick(index)}
                  >
                    <span 
                      className="d-flex align-items-center" 
                      dangerouslySetInnerHTML={{ __html: deleteIcon }} 
                    />
                    <span className="me-2 d-flex flex-nowrap text-nowrap">{t('kyb_flow.beneficiaries.delete')}</span>
                  </button>
                ) : (
                  <button
                    className={`btn btn-link size-12 font-weight-400 p-0 d-flex align-items-center justify-content-sm-end text-decoration-none w-100 ${isSubmitted ? 'text-dark' : 'hyperlink'}`}
                    onClick={() => onModalOpen(index, isBeneficiaryCard ? 'beneficiariesData' : 'rolesData')}
                  >
                    <span 
                      className="d-flex align-items-center" 
                      dangerouslySetInnerHTML={{ __html: isSubmitted ? editIcon : addIcon }} 
                    />
                    <span className="me-2 d-flex flex-nowrap text-nowrap">{isSubmitted ? t('kyb_flow.beneficiaries.edit') : t('kyb_flow.beneficiaries.enter_data')}</span>
                  </button>
                )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

interface CompanyRoleCardProps {
  member: Contact;
  isBeneficiaryCard: boolean;
  index: number;
  onModalOpen: (index: number, list?: ListType) => void;
  onDeleteClick: (index: number) => void;
}
